import { render, staticRenderFns } from "./RenewalDashboardWindow.vue?vue&type=template&id=33b453dd&scoped=true"
import script from "./RenewalDashboardWindow.vue?vue&type=script&lang=js"
export * from "./RenewalDashboardWindow.vue?vue&type=script&lang=js"
import style0 from "./RenewalDashboardWindow.vue?vue&type=style&index=0&id=33b453dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b453dd",
  null
  
)

export default component.exports